import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6a8c62c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rk" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rk_title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "rk_title_x" }),
  /*#__PURE__*/_createElementVNode("span", null, "选择机台设备")
], -1))
const _hoisted_3 = { class: "rk_list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["checked"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rk_zw" }, null, -1))

import { ref, onMounted } from 'vue'
    import { useRouter } from "vue-router"
    import { Toast } from 'vant'
    import { getListByUser } from '@/apis/WorkOrderAPI'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const router = useRouter()

    // 设备数据
    let data: any = ref([])

    // 跳转页面
    const jump = () => {
        let ids: any = []
        data.value.forEach((item: any) => {
            if (item.active) {
                ids.push(item.dmodel.id)
            }
        })
        if (ids.length === 0) {
            Toast({ message: '请先选择机台设备', duration: 2000 })
            return
        }
        // router.push({ name: 'warehousingTwo', query: { ids: ids.join(',') } })
        router.push({ name: 'newWipCompletion', query: { ids: ids.join(',') } })
    }

    // 点击设备
    const addIten = (i: number) => {
        data.value[i].active = !data.value[i].active
    }

    // 获取设备
    const getListByUsers = () => {
        getListByUser()
          .then((res: any) => {
              if (res.code === 200 && res.data && res.data.length !== 0) {
                  res.data.forEach((item: any) => {
                      item.active = false
                  })
                  data.value = res.data
              }
          })
    }

    onMounted(() => {
        getListByUsers()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "rk_list_item",
          key: index,
          onClick: ($event: any) => (addIten(index))
        }, [
          _createElementVNode("span", null, _toDisplayString(item.dmodel.code) + " - " + _toDisplayString(item.dmodel.name), 1),
          _createElementVNode("input", {
            type: "checkbox",
            checked: item.active
          }, null, 8, _hoisted_5)
        ], 8, _hoisted_4))
      }), 128))
    ]),
    _hoisted_6,
    _createElementVNode("div", { class: "rk_footer" }, [
      _createElementVNode("div", {
        class: "rk_footer_submit",
        onClick: jump
      }, "下一步")
    ])
  ]))
}
}

})